import b64toBlob from 'b64-to-blob';
import { Filesystem, Directory } from '@capacitor/filesystem';
import capacitorReady from 'lib/capacitor-init';


const STORAGE_DIR = Directory.Data;


function filePath( dir, name )
{
	return dir + '/' + name;
}


function mimeFromName( name )
{
	if( /\.jpe?g$/i.test( name ) ) return 'image/jpeg';
	if( /\.png$/i.test( name ) ) return 'image/png';
	if( /\.json$/i.test( name ) ) return 'application/json';
	return 'application/octet-stream';
}


function ensureDirectory( dir )
{
	return Filesystem.mkdir({
		path: dir,
		directory: STORAGE_DIR,
		recursive: true,
	}).catch(function() {
		// Le répertoire existe peut-être déjà
	});
}


/*
 * open( dir, name ) : retourne un File
 * read( dir, name, method = readAsText ) : Lit le Blob avec FileReader
 * write( dir, name, data, type ) | write( dir, name, Blob ) : écrit les données ou un Blob/File
 * remove( dir, name ) : Supprime
 */
export default {


	// Ouvre un fichier pour lecture ou ecriture
	open: function( dir, name )
	{
		var deferred = $.Deferred();
		var path = filePath( dir, name );

		console.log( 'FileStorage.open', dir, name, 'opening' );
		deferred.done( function( file ) { console.log( 'FileStorage.open', dir, name, 'ok', file ) } );
		deferred.fail( function( error ) { console.warn( 'FileStorage.open', dir, name, 'error', error ) } );

		capacitorReady.then(function()
		{
			return Filesystem.readFile({ path: path, directory: STORAGE_DIR });
		}).then(function( result )
		{
			var blob = b64toBlob( result.data, mimeFromName( name ) );
			blob.name = name;
			deferred.resolve( blob );
		}).catch( deferred.reject );

		return deferred;
	},



	// Écrit dans un fichier (en le créant si nécessaire
	write: function( dir, name, blob )
	{
		var deferred = $.Deferred();
		var path = filePath( dir, name );

		console.log( 'FileStorage.write', dir, name, '…' );
		deferred.done( function( text ) { console.log( 'FileStorage.write', dir, name, 'ok' ); } );
		deferred.fail( function( error ) { console.warn( 'FileStorage.write', dir, name, error ); } );

		var fr = new FileReader();
		fr.readAsDataURL( blob );
		fr.onload = _.bind( function()
		{
			var prefix = "data:" + blob.type + ";base64,";
			var data = fr.result.substr( prefix.length );

			capacitorReady.then(function()
			{
				return ensureDirectory( dir );
			}).then(function()
			{
				return Filesystem.writeFile({ path: path, data: data, directory: STORAGE_DIR });
			}).then(function()
			{
				deferred.resolve( blob );
			}).catch( deferred.reject );
		}, this );
		fr.onerror = deferred.reject;
		fr.onabort = deferred.reject;

		return deferred;
	},




	remove: function( dir, path )
	{
		var deferred = $.Deferred();
		var fullPath = filePath( dir, path );

		console.log( 'FileStorage.remove', dir, path, '…' );
		deferred.done( function( text ) { console.log( 'FileStorage.remove', dir, path, 'OK' ) } );
		deferred.fail( function( error ) { console.warn( 'FileStorage.remove', dir, path, 'ERROR', error ) } );

		capacitorReady.then(function()
		{
			return Filesystem.deleteFile({ path: fullPath, directory: STORAGE_DIR });
		}).then( deferred.resolve ).catch( deferred.reject );

		return deferred;
	},
}
